import {ApiContent} from '../../../application/contentLoaders/apiContent';

class CategoryContent extends ApiContent {
    /**
     * @param {string} endpoint
     * @param {Number} categoryId
     * @param {CallableFunction} loadedCallback
     */
    constructor(endpoint, categoryId, loadedCallback) {
        super(endpoint, {category: categoryId}, loadedCallback);
    }

    /**
     * @param {string} result.url
     * @param {string} result.name
     * @param {string} result.content_count
     * @param {Object} result
     * @returns {string}
     */
    formatResultTemplate(result) {
        if (!result.content_count) {
            return `<div class="-item"><a href="${result.url}" class="shoplist-nocodes">${result.name}</a></div>`;
        }

        return `<div class="-item"><a href="${result.url}">${result.name}</a> <span>(${result.content_count})</span></div>`;
    }
}

export {CategoryContent};
